import dayjs from "dayjs";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import AlertIcon, {
  AlertTriangleIcon,
} from "../../../../Common/Svgs/AlertIcon";
import { VerifySecondaryIcon } from "../../../../Common/Svgs/VerifyIcon";
import { updateTrikes } from "../../../../Redux/Slices/trikes.slice";

export const LicenseValidityColumn = ({ record }) => {
  const validity = record?.licenseValidity;

  const getData = () => {
    if (!validity) {
      return {
        value: "--",
        color: "text-primary",
        diff: null,
      };
    }

    const diff = dayjs(validity).diff(dayjs(), "month");
    let color = "text-primary";

    if (diff < 0) color = "text-alert-red";
    else if (diff >= 0 && diff <= 3) color = "text-warning";

    return {
      value: dayjs(validity).format("DD-MM-YYYY"),
      color,
      diff,
    };
  };

  const getIcon = (diff) => {
    if (diff < 0) {
      return (
        <AlertTriangleIcon size={12} className="-mt-0.5 stroke-alert-red" />
      );
    }

    if (diff >= 0 && diff <= 3) {
      return <AlertIcon size={12} className="text-warning" />;
    }

    return <VerifySecondaryIcon size={12} className="text-primary" />;
  };

  const { value, color, diff } = getData();

  return (
    <div className="flex items-center gap-x-1">
      {getIcon(diff)}
      <p className={`text-xs font-semibold font-aileron leading-4.5 ${color}`}>
        {value}
      </p>
    </div>
  );
};

export const DriverCurrentTrike = ({ detail }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { allTrikes } = useSelector((state) => state.trikes);

  const handleClick = (e) => {
    e.stopPropagation();

    if (detail.currentTrike) {
      const current = allTrikes.find(
        (item) => item.registrationNo === detail.currentTrike,
      );

      dispatch(
        updateTrikes({
          key: "currentTrike",
          value: current,
        }),
      );

      navigate(`/assets/trikes/${detail.currentTrike}`);
    }
  };

  return (
    <div
      className={`text-xs font-semibold font-aileron leading-4.5 text-dark-grey-text max-w-max ${
        detail.currentTrike && "cursor-pointer hover:text-black hover:underline"
      }`}
      onClick={handleClick}
    >
      {detail.currentTrike || "--"}
    </div>
  );
};
